import ThemeSetter from 'components/common/ThemeSetter'; // Adjust path if needed

import React from 'react';
import { Outlet } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import Feedback from 'views/Feedback';


const MinimalLayout = () => {
    
    return (
        
        <>
            {/* ===================================================================== */}
            {/* THIS IS THE NEW LOGIC */}
            {/* This one line commands the global context to use the post-login theme */}
            {/* for any page that uses MinimalLayout. */}
            <ThemeSetter mode="postLogin" />
            {/* ===================================================================== */}

            <CssBaseline />
            <Outlet />
            <Feedback />
        </>
    );
};

export default MinimalLayout;